<template>
  <div>
    <!-- Your component content goes here -->
    <!---------------------- Available parts section  -------------->
    <available-parts v-if="isAvailableItemsActive && avaliableItemsType === 'PARTS'"
      v-model="innerValue.parts"
      :quote-id="value.quoteId"
      :quote-no="value.quoteNo"
      :sub-quote-no="value.subQuoteNo"
      :page-size="1200"
      :sub-quote-nos="value.subQuoteNos"
      :is-audanet="value.audatex !== null"
      :next-line-number="nextLineNumber"
      :show-scroll-to-add="false"
      :vehicle-id="vehicle ? vehicle.id : ''"
      :selected-sub-sections="selectedSubSections"
      :selected-area="selectedArea"
      @item-added="onItemAddedPart" />
    <!--------------------- Supp Quote Main section  ------------------>
    <available-parts-main v-if="isMainActive && avaliableItemsType === 'PARTS'"
      v-model="innerValue.parts"
      :quote-id="value.quoteId"
      :quote-no="value.quoteNo"
      :page-size="1200"
      :sub-quote-no="value.subQuoteNo"
      :next-line-number="nextLineNumber"
      :selected-sub-sections="selectedSubSections"
      :selected-area="selectedArea"
      @item-added="onItemAddedPart" />

    <!---------------------- Available labour section  -------------->
    <available-labours v-if="isAvailableItemsActive && avaliableItemsType === 'LABOUR' && !isSundry"
      v-model="innerValue.labours"
      :quote-id="value.quoteId"
      :next-line-number="nextLineNumber"
      :is-audanet="value.audatex !== null"
      :rr-rate="findLabourRate(itemCategoryTypes.RR, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :rwa-rate="findLabourRate(itemCategoryTypes.RWA, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :repair-rate="findLabourRate(itemCategoryTypes.REP, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :paint-rate="findLabourRate(vehicle.paintGroup, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :shop-rate="value.shopRate"
      :vehicle-paint-group="vehicle.paintGroup"
      :quoting-method="value.quotingMethod"
      :page-size="1200"
      :schedule-id="vehicle.scheduleId"
      :body-id="vehicle.bodyId"
      :make="vehicle.model.make"
      :model="vehicle.model.model"
      :year="vehicleBuildYear"
      :labour-type="value.labourType"
      :is-ntar="isNtar"
      :show-scroll-on-add="false"
      :selected-sub-sections="selectedSubSections"
      :selected-area="selectedArea"
      @item-added="onItemAddedLabour" />

    <div v-if="isAvailableItemsActive && avaliableItemsType === 'LABOUR' && !!isSundry">
      <available-labour-sundry v-model="innerValue.labours"
        :shop-rate="value.shopRate"
        :next-line-number="nextLineNumber"
        :vehicle-paint-group="vehicle.paintGroup"
        :quoting-method="value.quotingMethod"
        :selected-area="selectedArea"
        @item-added="onItemAddedLabour" />
    </div>

    <!------------------- Supplementary quote Main section  -------------->
    <available-labours-main v-if="isMainActive && avaliableItemsType === 'LABOUR'"
      v-model="innerValue.labours"
      :quote-id="value.quoteId"
      :next-line-number="nextLineNumber"
      :quote-no="value.quoteNo"
      :sub-quote-no="value.subQuoteNo"
      :rr-rate="findLabourRate(itemCategoryTypes.RR, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :rwa-rate="findLabourRate(itemCategoryTypes.RWA, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :repair-rate="findLabourRate(itemCategoryTypes.REP, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :paint-rate="findLabourRate(vehicle.paintGroup, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :vehicle-paint-group="vehicle.paintGroup"
      :quoting-method="value.quotingMethod"
      :page-size="1200"
      :schedule-id="vehicle.scheduleId"
      :body-id="vehicle.bodyId"
      :make="vehicle.model.make"
      :model="vehicle.model.model"
      :year="vehicleBuildYear"
      :labour-type="innerValue.labourType"
      :selected-area="selectedArea"
      @item-added="onItemAddedLabour" />

    <!--------------------- Available other labour  ------------------>
    <available-other-labours v-if="isAvailableItemsActive && avaliableItemsType === 'OTHER' && !isLabourOtherNtar"
      v-model="innerValue.others"
      :quote-id="value.quoteId"
      :next-line-number="nextLineNumber"
      :is-audanet="value.audatex !== null"
      :quoting-method="value.quotingMethod"
      :page-size="1200"
      :fg-rate="findLabourRate(itemCategoryTypes.FIBER, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :crush-rate="findLabourRate(itemCategoryTypes.CRUSH, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :cd-rate="findLabourRate(itemCategoryTypes.CD, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :mech-rate="findLabourRate(itemCategoryTypes.MECH, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :shop-rate="value.shopRate"
      :is-ntar="isNtar"
      :selected-area="selectedArea"
      @item-added="onItemAddedOther" />
    <!--------------------- Available other labour NTAR  ------------------>
    <available-other-labours-ntar v-if="isAvailableItemsActive && avaliableItemsType === 'OTHER' && isNtar && !!isLabourOtherNtar"
      v-model="innerValue.others"
      :quote-id="value.quoteId"
      :next-line-number="nextLineNumber"
      :is-audanet="value.audatex !== null"
      :quoting-method="value.quotingMethod"
      :page-size="1200"
      :fg-rate="findLabourRate(itemCategoryTypes.FIBER, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :crush-rate="findLabourRate(itemCategoryTypes.CRUSH, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :cd-rate="findLabourRate(itemCategoryTypes.CD, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :mech-rate="findLabourRate(itemCategoryTypes.MECH, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :shop-rate="value.shopRate"
      :is-ntar="isNtar"
      :selected-area="selectedArea"
      @item-added="onItemAddedOther" />
    <!------------------- Supplementary quote Main section  -------------->
    <available-other-labours-main v-if="isMainActive && avaliableItemsType === 'OTHER'"
      v-model="innerValue.others"
      :quote-id="value.quoteId"
      :quote-no="value.quoteNo"
      :sub-quote-no="value.subQuoteNo"
      :next-line-number="nextLineNumber"
      :quoting-method="value.quotingMethod"
      :page-size="1200"
      :fg-rate="findLabourRate(itemCategoryTypes.FIBER, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :crush-rate="findLabourRate(itemCategoryTypes.CRUSH, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :cd-rate="findLabourRate(itemCategoryTypes.CD, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :mech-rate="findLabourRate(itemCategoryTypes.MECH, innerValue.rates, innerValue.shopRate, innerValue.quoteId).rate"
      :selected-area="selectedArea"
      @item-added="onItemAddedOther" />

    <!-------------------- Available Misc Section  ------------>
    <available-miscs v-if="isAvailableItemsActive && avaliableItemsType === 'MISC'"
      v-model="innerValue.miscs"
      :quote-id="value.quoteId"
      :labour-type="value.labourType"
      :next-line-number="nextLineNumber"
      :is-audanet="value.audatex !== null"
      :is-ntar="isNtar"
      :page-size="1200"
      :selected-area="selectedArea"
      @item-added="onItemAddedMisc" />

    <!---------------- Supplementry quote misc main section  -------->
    <available-miscs-main v-if="isMainActive && avaliableItemsType === 'MISC'"
      v-model="innerValue.miscs"
      :quote-id="value.quoteId"
      :quote-no="value.quoteNo"
      :sub-quote-no="value.subQuoteNo"
      :labour-type="value.labourType"
      :next-line-number="nextLineNumber"
      :page-size="1200"
      :selected-area="selectedArea"
      @item-added="onItemAddedMisc" />

    <!---------------------Available Sublet Section ----------->
    <available-sublets v-if="isAvailableItemsActive && avaliableItemsType === 'SUBLETS'"
      v-model="innerValue.sublets"
      :quote-id="value.quoteId"
      :labour-type="value.labourType"
      :next-line-number="nextLineNumber"
      :is-audanet="value.audatex !== null"
      :page-size="1200"
      :selected-area="selectedArea"
      @item-added="onItemAddedSublet" />

    <!---------------- Supplementry quote sublets main section  -------->
    <available-sublets-main v-if="isMainActive && avaliableItemsType === 'SUBLETS'"
      v-model="innerValue.sublets"
      :quote-id="value.quoteId"
      :quote-no="value.quoteNo"
      :sub-quote-no="value.subQuoteNo"
      :labour-type="value.labourType"
      :next-line-number="nextLineNumber"
      :page-size="1200"
      :selected-area="selectedArea"
      @item-added="onItemAddedSublet" />

  </div>
</template>

<script>
import {
  AvailableParts,
  AvailablePartsMain,
  AvailableLabours,
  AvailableLaboursMain,
  AvailableMiscs,
  AvailableMiscsMain,
  AvailableSublets,
  AvailableSubletsMain,
  AvailableOtherLabours,
  AvailableOtherLaboursMain
} from '@/views/quote/components'
import { LabourTimeTypes, ItemCategoryTypes, EventHubTypes } from '@/enums'
import { QuoteLabourMixin } from '../mixins'
import isEmpty from 'lodash.isempty'
import cloneDeep from 'lodash.clonedeep'
import deepDiff from 'deep-diff'
import AvailableLabourSundry from './sundryItemsComponents/AvailableLabourSundry'
import debounce from 'lodash.debounce'
import AvailableOtherLaboursNtar from '@/views/quote/components/AvailableOtherLaboursNtar'

const QUOTE_ITEM_COLLECTION_KEYS = ['parts', 'labours', 'miscs', 'sublets', 'others']

export default {
  name: 'AddItemsComponent',
  components: {
    AvailableParts,
    AvailableLabours,
    AvailableLaboursMain,
    AvailableMiscs,
    AvailableMiscsMain,
    AvailableSublets,
    AvailableSubletsMain,
    AvailableOtherLabours,
    AvailablePartsMain,
    AvailableOtherLaboursMain,
    AvailableLabourSundry,
    AvailableOtherLaboursNtar
  },
  mixins: [QuoteLabourMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },

    isAvailableItemsActive: {
      type: Boolean,
      required: true
    },
    isMainActive: {
      type: Boolean,
      required: true
    },
    avaliableItemsType: {
      type: String,
      required: true
    },
    nextLineNumber: {
      type: Number,
      required: true
    },
    isSundry: {
      type: Boolean,
      required: true
    },
    selectedSubSections: {
      type: Array,
      default: () => []
    },
    selectedArea: {
      type: String,
      default: null
    },
    isLabourOtherNtar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: null,
      totalAddedItems: 0,
      itemTypes: []
    }
  },
  computed: {
    isAvailableItemsMainActive() {
      return false
    },
    vehicleBuildYear() {
      return this.vehicle.buildYear ? Number(this.vehicle.buildYear) : this.vehicle.model.startYear ? Number(this.vehicle.model.startYear) : 0
    },
    itemCategoryTypes() {
      return ItemCategoryTypes
    },
    LabourTimeTypes() {
      return LabourTimeTypes
    },
    isNtar() {
      return (
        this.innerValue.labourType === LabourTimeTypes.NTAR ||
        this.innerValue.labourType === LabourTimeTypes.LTAR ||
        this.innerValue.labourType === LabourTimeTypes.eMTA
      )
    },
    isAudanet() {
      return this.value.isAudanet
    }
  },
  watch: {
    innerValue: {
      handler() {
        if (this._suppressNextInnerValueWatch) {
          this._suppressNextInnerValueWatch = false
          return
        }
        this._locallyDirty = true
        this.debouncedHandleUpdate()
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if (!this._seenRemoteIds) this._seenRemoteIds = new Set()
        this.recordSeenRemoteIds(newValue)
        if (!newValue) return

        const autoSaveOn = !!(this.$company && this.$company.setting && this.$company.setting.quoteAutoSaveEnabled)

        // Autosave OFF: echoes are never stale, so always reconcile fully — this is what lets
        // deletes made elsewhere (a part's paint loading + consumable) stick instead of being
        // resurrected by our next emit.
        if (!autoSaveOn) {
          this.reconcileFromParent(newValue)
          return
        }

        // Autosave ON: while a save is in flight an echo may be stale, so keep in-flight edits and
        // only mirror the isNew flip + deletions; otherwise reconcile fully.
        if (this._locallyDirty) {
          this.syncFlagsAndDeletions(newValue)
          return
        }
        this.reconcileFromParent(newValue)
      },
      deep: true
    },
    totalAddedItems() {
      if (this.totalAddedItems > 0) {
        this.notify()
      }
    }
  },
  created() {
    this._locallyDirty = false
    this._suppressNextInnerValueWatch = true
    this._hasUnsavedAdds = false
    this.innerValue = cloneDeep(this.value)
    // Ids the parent has ever sent us (see value watcher).
    this._seenRemoteIds = new Set()
    for (const key of QUOTE_ITEM_COLLECTION_KEYS) {
      const items = this.value && this.value[key]
      if (Array.isArray(items)) {
        for (const i of items) if (i && i.quoteItemId) this._seenRemoteIds.add(i.quoteItemId)
      }
    }
    this.debouncedHandleUpdate = debounce(() => {
      this.$emit('handleUpdate', cloneDeep(this.innerValue))
      this._locallyDirty = false
      // Trigger a save for freshly added items in case the parent watcher missed the splice.
      if (this._hasUnsavedAdds) {
        this._hasUnsavedAdds = false
        this.$eventHub.$emit(EventHubTypes.AutoSaveQuoteItems)
      }
    }, 150)
  },
  mounted() {
    this.$eventHub.$on('deleteLabour', this.onDeleteLabourItem)
    this.$eventHub.$on('deletePart', this.onDeletePartItem)
    this.$eventHub.$on('deleteMisc', this.onDeleteMiscItem)
    this.$eventHub.$on('deleteSubletItem', this.onDeleteSubletItem)
    this.$eventHub.$on('deleteOtherLabour', this.onDeleteOtherLabourItem)
    // Deletion signal covering the trash-button path the per-type events above miss.
    this.$eventHub.$on(EventHubTypes.QuoteItemDeletedSync, this.onQuoteItemDeletedSync)
  },
  beforeDestroy() {
    this.debouncedHandleUpdate.cancel()
    this.$eventHub.$off('deleteLabour', this.onDeleteLabourItem)
    this.$eventHub.$off('deletePart', this.onDeletePartItem)
    this.$eventHub.$off('deleteMisc', this.onDeleteMiscItem)
    this.$eventHub.$off('deleteSubletItem', this.onDeleteSubletItem)
    this.$eventHub.$off('deleteOtherLabour', this.onDeleteOtherLabourItem)
    this.$eventHub.$off(EventHubTypes.QuoteItemDeletedSync, this.onQuoteItemDeletedSync)
  },
  methods: {
    // Drop a just-deleted new item from innerValue (existing items are reconciled via the value echo).
    onQuoteItemDeletedSync(item) {
      if (!item || !item.quoteItemId || !item.isNew || !this.innerValue) return
      for (const key of QUOTE_ITEM_COLLECTION_KEYS) {
        const arr = this.innerValue[key]
        if (!Array.isArray(arr)) continue
        const idx = arr.findIndex(i => i && i.quoteItemId === item.quoteItemId)
        if (idx >= 0) {
          arr.splice(idx, 1)
          break
        }
      }
    },
    // Remember every id the parent echoes, so a pending add (never seen) is distinguishable from
    // an item deleted elsewhere (seen, now absent).
    recordSeenRemoteIds(newValue) {
      if (!newValue) return
      for (const key of QUOTE_ITEM_COLLECTION_KEYS) {
        const remoteItems = newValue[key]
        if (!Array.isArray(remoteItems)) continue
        for (const r of remoteItems) {
          if (r && r.quoteItemId) this._seenRemoteIds.add(r.quoteItemId)
        }
      }
    },
    // Autosave ON, mid-save: mirror only the isNew flip and deletions; never overwrite present
    // items' field values (a stale echo must not clobber an in-flight local edit).
    syncFlagsAndDeletions(newValue) {
      for (const key of QUOTE_ITEM_COLLECTION_KEYS) {
        const localItems = this.innerValue && this.innerValue[key]
        const remoteItems = newValue[key]
        if (!Array.isArray(localItems) || !Array.isArray(remoteItems)) continue
        const remoteById = new Map()
        for (const r of remoteItems) {
          if (r && r.quoteItemId) remoteById.set(r.quoteItemId, r)
        }
        for (let i = localItems.length - 1; i >= 0; i--) {
          const localItem = localItems[i]
          if (!localItem || !localItem.quoteItemId) continue
          const remote = remoteById.get(localItem.quoteItemId)
          if (remote) {
            if (localItem.isNew === true && remote.isNew === false) localItem.isNew = false
            if ((remote.deleted || remote.isDeleted) && !(localItem.deleted || localItem.isDeleted)) {
              localItem.deleted = true
              localItem.isDeleted = true
              if (remote.itemStatus !== undefined) localItem.itemStatus = remote.itemStatus
            }
          } else if (this._seenRemoteIds.has(localItem.quoteItemId)) {
            localItems.splice(i, 1)
          }
        }
      }
    },
    // Take the parent state, but keep pending adds (isNew, never echoed) and never revert a
    // confirmed isNew=false back to true.
    reconcileFromParent(newValue) {
      if (!deepDiff(this.innerValue, newValue)) return
      const merged = cloneDeep(newValue)
      let preservedLocal = false
      for (const key of QUOTE_ITEM_COLLECTION_KEYS) {
        if (!Array.isArray(this.innerValue[key])) continue
        if (!Array.isArray(merged[key])) merged[key] = []
        const localById = new Map()
        for (const l of this.innerValue[key]) {
          if (l && l.quoteItemId) localById.set(l.quoteItemId, l)
        }
        for (const m of merged[key]) {
          if (!m || !m.quoteItemId) continue
          const local = localById.get(m.quoteItemId)
          if (local && local.isNew === false && m.isNew === true) m.isNew = false
        }
        const newIds = new Set(merged[key].map((i) => i && i.quoteItemId).filter(Boolean))
        for (const localItem of this.innerValue[key]) {
          if (
            localItem &&
            localItem.isNew &&
            localItem.quoteItemId &&
            !newIds.has(localItem.quoteItemId) &&
            !this._seenRemoteIds.has(localItem.quoteItemId)
          ) {
            merged[key].push(cloneDeep(localItem))
            preservedLocal = true
          }
        }
      }
      if (preservedLocal) {
        this._locallyDirty = true
        this.innerValue = merged
        this.debouncedHandleUpdate()
      } else {
        this._suppressNextInnerValueWatch = true
        this.innerValue = merged
      }
    },
    onItemAddedPart(newItem) {
      this.innerValue.lines = newItem.lineNumber + 1
      this.innerValue.parts.splice(this.innerValue.parts.length, 1, newItem)

      this.totalAddedItems += 1
      this._hasUnsavedAdds = true
      // this.$notification.openNotificationWithType('success', '', 'Part added')
      this.$eventHub.$emit('itemAddedButterfly', newItem.quoteItemId)
    },
    onItemAddedLabour(newItems) {
      if (!isEmpty(newItems)) {
        const vm = this
        newItems.forEach(function (item) {
          vm.innerValue.labours.splice(vm.innerValue.labours.length, 1, item)
          if (vm.isNtar && item.hourValue > 0 && (item.itemType === ItemCategoryTypes.REP || item.itemType === ItemCategoryTypes.PAINT)) {
            vm.addUpdateRepairPaintLoading(item)
          }
        })
        this.innerValue.lines = Math.max(...newItems.map((i) => i.lineNumber), 0) + 1

        this.totalAddedItems += newItems.length
        this._hasUnsavedAdds = true
        // this.$notification.openNotificationWithType('success', '', `Labour Item${newItems.length > 1 ? 's' : ''} added`)
      }

      const focusOnHour = !newItems[0].hourValue && !newItems[0].hourValue > 0

      this.$eventHub.$emit('itemAddedButterfly', newItems[0].quoteItemId, false, focusOnHour)
    },
    onItemAddedMisc(newItem) {
      this.innerValue.lines = newItem.lineNumber + 1
      this.innerValue.miscs.splice(this.innerValue.miscs.length, 1, newItem)

      this.totalAddedItems += 1
      this._hasUnsavedAdds = true
      // this.$notification.openNotificationWithType('success', '', 'Miscallaneaous Item added')
      this.$eventHub.$emit('itemAddedButterfly', newItem.quoteItemId)
    },
    onItemAddedSublet(newItem) {
      this.innerValue.lines = newItem.lineNumber + 1
      this.innerValue.sublets.splice(this.innerValue.sublets.length, 1, newItem)

      this.totalAddedItems += 1
      this._hasUnsavedAdds = true
      // this.$notification.openNotificationWithType('success', '', 'Item added')
      this.$eventHub.$emit('itemAddedButterfly', newItem.quoteItemId)
    },
    onItemAddedOther(newItems) {
      if (!isEmpty(newItems)) {
        const vm = this
        newItems.forEach(function (item) {
          vm.innerValue.others.splice(vm.innerValue.others.length, 1, item)
        })
        this.innerValue.lines = Math.max(...newItems.map((i) => i.lineNumber), 0) + 1

        this.totalAddedItems += newItems.length
        this._hasUnsavedAdds = true
        // this.$notification.openNotificationWithType('success', '', `Item${newItems.length > 1 ? 's' : ''} added`)
        this.$eventHub.$emit('itemAddedButterfly', newItems[0].quoteItemId)
      }
    },
    notify: debounce(function () {
      this.$notification.openNotificationWithType('success', '', `${this.totalAddedItems} Item${this.totalAddedItems > 1 ? 's' : ''} added`)
      this.totalAddedItems = 0
    }, 1500),
    // When a newly-added (isNew) item is deleted via the event hub the deletion
    // only removes it from the item-type component's own innerValue — spliced items
    // are not reflected back into AddItemsComponent.innerValue automatically.
    // Without this sync, the stale item stays in innerValue and the next handleUpdate
    // emission re-introduces it, causing the button to stay blue and the deleted item
    // to reappear when adding the next item.
    onDeleteLabourItem(item) {
      if (item && item.isNew) {
        const idx = this.innerValue.labours.findIndex(i => i.quoteItemId === item.quoteItemId)
        if (idx >= 0) this.innerValue.labours.splice(idx, 1)
      }
    },
    onDeletePartItem(item) {
      if (item && item.isNew) {
        const idx = this.innerValue.parts.findIndex(i => i.quoteItemId === item.quoteItemId)
        if (idx >= 0) this.innerValue.parts.splice(idx, 1)
      }
    },
    onDeleteMiscItem(item) {
      if (item && item.isNew) {
        const idx = this.innerValue.miscs.findIndex(i => i.quoteItemId === item.quoteItemId)
        if (idx >= 0) this.innerValue.miscs.splice(idx, 1)
      }
    },
    onDeleteSubletItem(item) {
      if (item && item.isNew) {
        const idx = this.innerValue.sublets.findIndex(i => i.quoteItemId === item.quoteItemId)
        if (idx >= 0) this.innerValue.sublets.splice(idx, 1)
      }
    },
    onDeleteOtherLabourItem(item) {
      if (item && item.isNew) {
        const idx = this.innerValue.others.findIndex(i => i.quoteItemId === item.quoteItemId)
        if (idx >= 0) this.innerValue.others.splice(idx, 1)
      }
    }
  }
}
</script>

<style lang="scss">
@use "@/assets/style/override-colours" as oc;

.table-container-avaialble-butterfly-items {
  max-height: calc(100vh - 52px - 52px - 250px);
  overflow-y: auto;

  /* remove border from table body and headings */
  td {
    border: none;
  }

  th {
    font-weight: 100 !important;
  }

  tfoot {
    display: none;
  }

  .butterfly-item-values {
    cursor: pointer;

    border: 1px solid oc.$grey;
    border-radius: 5px;
    align-self: center;
    padding-left: 3px;
    padding-right: 3px;

    &.is-selected {
      color: white;
      background-color: oc.$primary;
      border: oc.$primary 1px solid;
    }

    &:hover {
      color: oc.$primary;
      border: oc.$primary 1px solid;
    }

    &.is-selected:hover {
      color: white;
      border: oc.$danger 1px solid;
    }
  }
}
</style>